import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { useToast } from "@/components/ui/use-toast";
import { Shield, AlertTriangle, Brain, TrendingUp } from "lucide-react";
import RiskAssessment from "./RiskAssessment";
import RiskAnalytics from "./RiskAnalytics";
import BehaviorAnalysis from "@/components/admin/risk/BehaviorAnalysis";
import AISettings from "@/components/admin/settings/AISettings";

const RiskManagement = () => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Risk Management System</h1>
        <Shield className="h-8 w-8 text-primary" />
      </div>

      <Tabs defaultValue="assessment" className="space-y-4">
        <TabsList className="grid grid-cols-4 gap-4">
          <TabsTrigger value="assessment" className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" />
            Risk Assessment
          </TabsTrigger>
          <TabsTrigger value="analytics" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Risk Analytics
          </TabsTrigger>
          <TabsTrigger value="behavior" className="flex items-center gap-2">
            <Brain className="h-4 w-4" />
            Behavior Analysis
          </TabsTrigger>
          <TabsTrigger value="settings" className="flex items-center gap-2">
            <Shield className="h-4 w-4" />
            AI Settings
          </TabsTrigger>
        </TabsList>

        <TabsContent value="assessment">
          <RiskAssessment />
        </TabsContent>

        <TabsContent value="analytics">
          <RiskAnalytics />
        </TabsContent>

        <TabsContent value="behavior">
          <Card className="p-6">
            <BehaviorAnalysis />
          </Card>
        </TabsContent>

        <TabsContent value="settings">
          <AISettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default RiskManagement;